export enum ArchivedCurrentProjectActionType {
    RESET_PROJECT = 'RESET_PROJECT',
}
